var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-title",
        [
          _vm._t("title"),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              style: { padding: "0 0 0 0" },
              attrs: { icon: "", flat: "" },
              on: {
                click: function ($event) {
                  return _vm.openSettings()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "cog" } })],
            1
          ),
        ],
        2
      ),
      _vm.allEvents.length > 0
        ? _c(
            "w-scroll-view",
            { attrs: { tag: "w-card-content" } },
            _vm._l(_vm.allEvents, function (event, i) {
              return _c("app-calendar-widget-item", {
                key: i,
                attrs: {
                  title: event.text,
                  color: event.color,
                  "start-time": event.startTime,
                  "end-time": event.endTime,
                  location: event.location,
                },
              })
            }),
            1
          )
        : _c(
            "w-row",
            { attrs: { center: "", grow: "" } },
            [
              _c(
                "w-col",
                { attrs: { center: "" } },
                [
                  _c("w-fa", {
                    staticClass: "gray checkmark",
                    attrs: { icon: "calendar-check" },
                  }),
                  _c("div", { staticClass: "gray mt" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("no-planned-events")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.settingsModal,
            callback: function ($$v) {
              _vm.settingsModal = $$v
            },
            expression: "settingsModal",
          },
        },
        [
          _c("app-calendar-widget-settings", {
            on: {
              close: function ($event) {
                _vm.settingsModal = false
              },
              save: function ($event) {
                return _vm.fetch()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }